import type { ReactNode } from "react";
import { useMemo, useEffect } from "react";
import * as Styled from "./style";
import { FooterBlock } from "~/components/blocks/layout/footer-block";
import { GlobalNavi } from "~/components/blocks/layout/global-navi";
import { isAvailableHoverVar, shouldShowPreviewModalVar } from "~/components/blocks/layout/store";
import { useDisabledAdult } from "~/hooks/use-disabled-adult";
import { useGetFooterHeight } from "~/hooks/use-get-footer-height";
import { useGetFooterRefResize } from "~/hooks/use-get-footer-ref-resize";
import { useMatchMedia } from "~/hooks/use-match-media";
import { useShowGlobalNaviAndFooter } from "~/hooks/use-show-global-navi-and-footer";

export type LayoutProps = {
  children: ReactNode;
};

/**
 * ページ全体で共通利用するコンポーネントをまとめるコンポーネント
 * @param props {@link LayoutProps}
 */
export const Layout = ({ children }: LayoutProps) => {
  const { isShowGlobalNaviAndFooter } = useShowGlobalNaviAndFooter();
  const { footerRef } = useGetFooterRefResize();
  const { availableHover, isSpSize } = useMatchMedia();

  const shouldShowPreviewModal = useMemo(() => !isSpSize, [isSpSize]);

  useDisabledAdult();
  useEffect(() => {
    isAvailableHoverVar(availableHover);
    shouldShowPreviewModalVar(shouldShowPreviewModal);
  }, [availableHover, shouldShowPreviewModal]);

  return (
    <>
      {isShowGlobalNaviAndFooter && <GlobalNavi />}
      <Styled.MainLayout id="main-layout" footerHeight={useGetFooterHeight()}>
        {children}
      </Styled.MainLayout>
      {isShowGlobalNaviAndFooter && <FooterBlock ref={footerRef} />}
    </>
  );
};
